import { combineReducers } from "redux"
import webroot from "./webroot/rootReducer"
import notificationChannels from "js/state/reducers/notificationChannels"

export default combineReducers({
  webroot,
  notificationChannels,
})
